import React, { useEffect, useState } from "react";
import { dataDecrypt, dataEncrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import { useNavigate, useParams } from "react-router-dom";
import { IMAGE_PATH } from "../../../config";
import noImage from "../../../assets/images/no-image.webp";
import noProducts from "../../../assets/images/products.png" 
import { BiPlusCircle } from "react-icons/bi";

export const OrgProducts = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [pageCount, setPageCount] = useState<any>({
    id: params.org,
    filter: {
      limit: 10,
      page: 0,
    },
  });
  const [productsData, setProductsData] = useState<any>([]);
  const [filterProductData, setFilterProductData] = useState<any>([]);

  useEffect(() => {
    loadProducts();
  }, []);

  async function loadProducts(): Promise<void> {
    setLoading(true);
    try {
      let encryptedData = encrypt(JSON.stringify(pageCount));
      const res = await ApisService.productApi(
        "getProductsList_v5",
        encryptedData
      );
      const productsData = JSON.parse(dataDecrypt(res.data.data));
      setProductsData(productsData.results);
      setFilterProductData(productsData.results)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error in transaction:", error);
    }
  }

  const getProductInfo = (item: any) => {
    navigate(
      `/dashboard/organizations/org-details/${params.page}/${params.org}/products/${item.id}`
    );
  };

  const handleInput = (value: string) => {
    setSearchText(value);
    if (value.trim() === "") {
      setProductsData(filterProductData);
    } else {
      const filtered = filterProductData.filter(
        (item: any) =>
          item?.name?.toLowerCase().includes(value?.toLowerCase()) 
      );
      setProductsData(filtered);
    }
  };

  const ProductBulkUpload=()=>{
    const encryptData = dataEncrypt(JSON.stringify({id:params.org}));
    window.open(`/products/bulkupload/${encryptData}`);
  }

  const getImageSrc = (images: any) => {
    if (!images) return noImage;

    if (Array.isArray(images) && images.length > 0) {
      console.log(images.length,"images.length");
      return `${IMAGE_PATH}/${images[0]}`;
    }

    if (typeof images === "string") {
      return `${IMAGE_PATH}/${images}`;
    }

    return noImage;
  };


  return (
    <div className="">
      <div className="text-end my-2"><button className="px-4 rounded primary-bg text-white border-0 align-items py-1" onClick={()=>ProductBulkUpload()}> <BiPlusCircle className="me-1" size={20}/> Product Bulk Upload</button></div>
      <div className="row mt-2">
        <div className="col-md-12">
        <input type="search" className="form-control rounded-pill primary-border fs-14 mt-2 py-2 box-shadow" placeholder="search by product name" value={searchText} onChange={(e) => handleInput(e.target.value)}/>
        </div>
      </div>
      <div className="col-12 px-0 my-2">
        {loading && (
          <div className="text-center p-5">
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        )}
        {!loading && (
          <div>
            <div className="row">
              {productsData.length>0 ?
                (productsData?.map((value: any, index: any) => (
                  <div className="col-md-2" key={index}>
                    <div
                      className="card mb-2 cursor-pointer box-shadow"
                      onClick={() => getProductInfo(value)}
                    > 
                      <img
                        src={getImageSrc(value?.images)}
                        alt="product image"
                        className={(value?.images) ? "rounded-top object-fit-cover":"rounded-top object-fit-contain"}
                        style={{ height: "100px" }}
                      />
                      <h6 className="text-center my-3 text-truncate px-2 fs-15 fw-bold">
                        {value?.name}
                      </h6>
                      <div className="px-2 lh-1 fs-14">
                        Price : ₹ {value?.batch_pricing[0]?.price}
                      </div>
                      <div className="px-2 fs-14">
                        Quantity : {value?.batch_pricing[0]?.quantity?.toFixed(2)}{" "}
                        <span className="ms-1">
                          {value?.batch_pricing[0]?.quantity_in}
                        </span>
                      </div>
                    </div>
                  </div>
                ))):<div className="text-center">
                  <img src={noProducts} className="product-image" style={{objectFit:'contain'}}/>
                  <h5 className="mt-2 text-dark">NO PRODUCTS FOUND</h5>
                  </div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
